import { Controller } from '@hotwired/stimulus'
import { Helpers } from '../helpers';

export default class extends Controller {
  static targets = [
    'payinMethodRadioButtons',
    'cardExplanation',
    'formSubmitButton',
    'modalButton',
    'modalAmount',
    'copiableModalAmount',
  ]

  changePayinMethod(event) {
    const isPayingByCard = event.target.value === 'card';
    this.cardExplanationTarget.classList.toggle('d-none', !isPayingByCard);
    this.formSubmitButtonTarget.classList.toggle('d-none', !isPayingByCard);
    this.modalButtonTarget.classList.toggle('d-none', isPayingByCard);
  }

  changeModalAmount(event) {
    const amount = Helpers.numberToCurrency(event.target.value, 2);
    this.modalAmountTarget.innerHTML = amount;
    this.copiableModalAmountTarget.dataset.targetValue = amount;
  }
}
